export default {
  "Loop as a GIF": "GIF로 반복재생하기",
  "without sound": "소리 없이",
  "Final output duration": "최종 출력 지속시간",
};
